import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from 'firebase/firestore'

import { db } from 'utils/firebase'

import { Bookmark } from 'types/bookmark'
import { Data, Options } from 'types/query'

import { formatDocSnapshot, formatQuerySnapshot } from './formatFirestoreResults'
import { formatQueryOptions } from './formatQueryOptions'

const DOC = 'bookmarks'

export const postBookmark = async (data: Data, options: Options<any> = {}) => {
  const { post, user, created } = data

  const bookmark = await fetchBookmark({ postId: post.id, userId: user.id })
  if (bookmark) {
    return bookmark
  }

  const bookmarksRef = collection(db, DOC)

  const newBookmarkRef = await addDoc(bookmarksRef, {
    post,
    user,
    created,
  })

  const newBookmark = await getDoc(newBookmarkRef)
  return formatDocSnapshot(newBookmark)
}

export const fetchBookmark = async ({
  postId,
  userId,
}: {
  postId?: string
  userId?: string
}): Promise<Bookmark | null> => {
  if (!postId || !userId) {
    throw new Error('Error fetching bookmark')
  }
  const q = query(
    collection(db, DOC),
    where('post.id', '==', postId),
    where('user.id', '==', userId),
  )
  const querySnapshot = await getDocs(q)
  const results = formatQuerySnapshot(querySnapshot)

  return results.length > 0 ? results[0] : null
}

export const fetchBookmarks = async (
  {
    userId,
  }: {
    userId?: string
  },
  options: Options<Bookmark> = {
    orderDirection: 'desc',
  },
): Promise<Bookmark[]> => {
  if (!userId) {
    throw new Error('Error fetching bookmarks')
  }
  const baseQuery = query(
    collection(db, DOC),
    where('user.id', '==', userId),
    where('post.isArchived', '==', false),
  )
  const queryWithOptions = formatQueryOptions(baseQuery, options)
  const querySnapshot = await getDocs(queryWithOptions)
  return formatQuerySnapshot(querySnapshot)
}

export const deleteBookmark = async ({ bookmarkId }: { bookmarkId?: string }) => {
  if (!bookmarkId) {
    throw new Error('Error deleting bookmark')
  }
  const followRef = doc(db, DOC, bookmarkId)
  await deleteDoc(followRef)
}
